import * as Types from '@/types/productivity-schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql-productivity';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type P_PollPersonKnowledgeQueryVariables = Types.Exact<{
  personId: Types.Scalars['ID']['input'];
}>;


export type P_PollPersonKnowledgeQuery = { pollPersonKnowledge?: any | null };


export const P_PollPersonKnowledgeDocument = /*#__PURE__*/ gql`
    query p_PollPersonKnowledge($personId: ID!) {
  pollPersonKnowledge(personId: $personId)
}
    `;

export function useP_PollPersonKnowledgeQuery(options: Omit<Urql.UseQueryArgs<P_PollPersonKnowledgeQueryVariables>, 'query'>) {
  return Urql.useQuery<P_PollPersonKnowledgeQuery, P_PollPersonKnowledgeQueryVariables>({ query: P_PollPersonKnowledgeDocument, ...options });
};